import BaseComponent from './BaseComponent';
// import Swiper        from 'swiper';
import { throttle }  from 'lodash';

class SliderFeatured extends BaseComponent {
  constructor(componentName, autoInit = true){
    super(componentName);

    this.options = {
      wrapperClass: 'slides-list',
      slideClass: 'slide',
      // centeredSlides: true,
      slidesPerView: 'auto',  // Default slides per view
      spaceBetween: 20,
      loop: false,
      navigation: {
        prevEl: '.slider__btn--prev',
        nextEl: '.slider__btn--next'
      },
      pagination: {
        el: '.slider__pagination',
        clickable: true,
      },
      grabCursor: true,
      speed: 300,
      // watchOverflow: true,
      on: {
        init: function () {
          // console.log('swiper initialized');
        },
      }
    };

    this.classElement = `.${componentName}`;
    autoInit ? this.autoInit() : '';
  }


  init(component) {}


  autoInit() {
    this.slider = new Swiper(this.classElement, this.options);
  }

  update() {
    this.slider = new Swiper(this.classElement, this.options);
  }

}

export default SliderFeatured;
